<template>
  <v-card>
    <v-card-title primary-title>
      <div>
        <div class="headline secondary--text">
          {{ $t("company.companies.title") }}
        </div>
        <span class="body-1 grey--text text--darken-1">{{
          $t("company.companies.subtitle")
        }}</span>
      </div>
      <v-spacer></v-spacer>
      <CreateCompanyDialog></CreateCompanyDialog>
    </v-card-title>
    <v-card-text>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          color="primary"
          append-outer-icon="search"
          :label="$t('company.search.label')"
          single-line
          hide-details
          @keyup.enter="getApiData"
          @click:clear="clearSearch"
          @click:append-outer="getApiData"
          clear-inner-icon="rms_close"
          clearable
        ></v-text-field>
      </v-card-title>
      <div v-if="list.length > 0">
        <template v-for="company in list">
          <v-card :key="company.id">
            <v-card-text>
              <v-list-tile>
                <v-list-tile-avatar size="20" style="min-width: 30px">
                  <v-tooltip
                    v-if="company.is_screening_pricing_enterprise"
                    slot="append"
                    top
                    color="white"
                  >
                    <v-icon slot="activator" color="blue" size="20"
                      >$vuetify.icons.enterprise</v-icon
                    >
                    <span class="greyDarken3--text body-1">
                      {{ $t("enterprise.tooltip") }}
                    </span></v-tooltip
                  >
                </v-list-tile-avatar>
                <v-list-tile-avatar size="50">
                  <img
                    v-if="company.logo_url"
                    :src="company.logo_url"
                    alt="avatar"
                  />
                  <avatar v-else :username="company.title"></avatar>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>
                    <span v-html="company.title">{{ company.title }}</span>
                    <span>&nbsp;•&nbsp;</span>
                    <span class="grey--text text--darken-2">
                      {{ DEFINES.ROLE_STR[company.pivot.role] }}
                    </span>
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    <span class="grey--text text--darken-2">
                      {{
                        moment
                          .utc(company.created_at)
                          .local()
                          .format("MMM D, YYYY")
                      }}
                    </span>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action v-if="company.subscription">
                  <v-tooltip top color="white" max-width="300" nudge-top="10">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        small
                        round
                        flat
                        :color="
                          DEFINES.SUBSCRIPTION_STATUS_CANCELED !=
                          company.subscription_status
                            ? 'success'
                            : 'error'
                        "
                        v-on="on"
                        :to="{
                          name: 'SubscriptionDashboard',
                          params: {
                            company_id: company.id,
                            subscription_id: company.subscription,
                          },
                        }"
                        >{{ $t("subscription.status.subscribed") }}</v-btn
                      >
                    </template>
                    <div>
                      <span class="grey--text text--darken-3 body-1">
                        {{ $t("subscription.title") }}&nbsp;{{
                          DEFINES.SUBSCRIPTION_STATUS_CANCELED !=
                          company.subscription_status
                            ? DEFINES.SUBSCRIPTION.STATUS.ACTIVE
                            : DEFINES.SUBSCRIPTION.STATUS.CANCELED
                        }}
                      </span>
                    </div>
                  </v-tooltip>
                </v-list-tile-action>
                <v-list-tile-action>
                  <v-tooltip slot="append" top color="white" max-width="300">
                    <v-btn
                      icon
                      ripple
                      slot="activator"
                      :to="{
                        name: 'CompanyDashboard',
                        params: { company_id: company.id },
                      }"
                    >
                      <v-icon color="secondary"
                        >$vuetify.icons.rms_company_select_icon</v-icon
                      >
                    </v-btn>
                    <span class="grey--text text--darken-3 body-1">
                      {{ $t("company.list.select_company.title") }}
                    </span>
                  </v-tooltip>
                </v-list-tile-action>
                <v-list-tile-action
                  v-if="
                    company.pivot && company.pivot.role === DEFINES.ROLE_OWNER
                  "
                >
                  <ConfirmationDialog
                    :desc="'company.confirmation.delete.description'"
                    :action="getDialogAction(company, 'rms_delete', 'error')"
                    :headline="'company.confirmation.delete.heading'"
                    :button_type="'icon'"
                  ></ConfirmationDialog>
                </v-list-tile-action>
              </v-list-tile>
            </v-card-text>
            <v-divider></v-divider>
          </v-card>
        </template>
        <div
          class="text-xs-right pt-4"
          v-if="pagination.total > pagination.perPage"
        >
          <v-pagination
            color="secondary"
            v-model="pagination.page"
            :length="pages"
          ></v-pagination>
        </div>
      </div>

      <v-layout v-else row wrap justify-center align-center>
        <v-flex xs12>
          <v-layout column justify-center align-center>
            <v-img
              src="../../assets/create.svg"
              width="40%"
              height="100%"
            ></v-img>
             <div class="mt-5 my-3 text-xs-center" v-if="search">
              <div class="headline grey--text text--darken-2">
                {{ $t("company.not_found") }}
              </div>
              <div class="body-1 grey--text text--darken-1">
                {{ $t("try_diff_keyword_msg") }}
              </div>
             </div>
            <div class="mt-5 my-3 text-xs-center" v-else>
              <div class="headline grey--text text--darken-2">
                {{ $t("company.create.title") }}
              </div>
              <div class="body-1 grey--text text--darken-1">
                {{ $t("rms.user_has_no_companies_text") }}
              </div>
            </div>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import CreateCompanyDialog from "./CreateDialog";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import Avatar from "vue-avatar";
export default {
  components: {
    CreateCompanyDialog,
    ConfirmationDialog,
    Avatar,
  },
  data() {
    return {
      search: "",
      pagination: {
        page: 1,
        total: 0,
        perPage: 20,
      },
      desserts: [
        {
          name: "Frozen Yogurt",
          calories: 159,
          fat: 6.0,
          carbs: 24,
          protein: 4.0,
          iron: "1%",
        },
      ],
    };
  },
  watch: {
    "pagination.page": function () {
      this.onPageChange();
    },
  },
  mounted() {
    this.getApiData();
  },
  methods: {
    clearSearch() {
        this.search = "";
        this.getApiData();
    },
    onPageChange() {
      this.getApiData();
    },
    async onDelete(company) {
      try {
        var data = await this.$store.dispatch("company/delete", company);

        await this.$store.dispatch("company/list", company);

        this.$store.dispatch("app/showMessage", {
          message: i18n.t("message.success.deleted"),
          color: this.DEFINES.SNACKBAR_SUCCESS_COLOR,
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
    getDialogAction(update_status, btn_icon, btn_color) {
      return {
        button_icon: btn_icon,
        button_color: btn_color,
        method: this.onDelete,
        payload: update_status,
      };
    },
    async getApiData() {
      let response = await this.$store.dispatch("company/list", {
       filter: { 
          perPage: this.pagination.perPage,
          search:this.search,
          sort_by: {by: 'created_at', dir: 'DESC'},
        },
       page: this.pagination.page,
      });
      if (response) {
        this._syncPagination(response);
      }
    },
    _syncPagination(response) {
      this.pagination.page = response.companies.current_page;
      this.pagination.total = response.companies.total;
      this.pagination.perPage = response.companies.per_page;
    },
  },

  computed: {
    ...mapState({
      list: (state) => state.company.list,
    }),
    pages() {
      return Math.ceil(this.pagination.total / this.pagination.perPage);
    },
  },
};
</script>
<style scoped>
.v-list__tile {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
</style>
